import { render } from "./BlogDetail.vue?vue&type=template&id=1d82245b&scoped=true"
import script from "./BlogDetail.vue?vue&type=script&lang=js"
export * from "./BlogDetail.vue?vue&type=script&lang=js"

import "./BlogDetail.vue?vue&type=style&index=0&id=1d82245b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d82245b"]])

export default __exports__